/**
 * RegistrationPricingTable - Pricing table for program registration panels.
 */

import React from 'react';
import { ECGridColors } from '@/types/colors';

export interface PricingRow {
  label: string;
  value: string;
}

interface Props {
  title?: string;
  rows: PricingRow[];
}

export const RegistrationPricingTable: React.FC<Props> = ({ title, rows }) => (
  <div className="overflow-hidden rounded-lg border border-gray-200 shadow-sm">
    <table className="w-full text-sm text-left border-collapse">
      <tbody className="divide-y divide-gray-200">
        {title && (
          <tr style={{ backgroundColor: '#e7f3f8' }}>
            <th
              colSpan={2}
              className="px-4 py-2.5 font-semibold"
              style={{ color: ECGridColors.tealDark }}
            >
              {title}
            </th>
          </tr>
        )}
        {rows.map((row, idx) => (
          <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
            <th className="px-4 py-2.5 font-medium text-gray-600 w-2/5 align-top whitespace-nowrap">
              {row.label}
            </th>
            <td className="px-4 py-2.5 text-gray-900">{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
